import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubjectService {

  private stateContract = new Subject<string>();
  public stateContract$ = this.stateContract.asObservable();

  constructor() { }

  changeStateContract(state: string) {
    this.stateContract.next(state);
  }
}
